export default __webpack_public_path__ + "542366981637443f4aa74a817bb53c42.png";